"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _allowed = _interopRequireDefault(require("../utils/allowed"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Tbody = function Tbody(props) {
  return /*#__PURE__*/_react["default"].createElement("tbody", _extends({
    "data-testid": "tbody"
  }, (0, _allowed["default"])(props)));
};

var _default = Tbody;
exports["default"] = _default;